import { z } from 'zod';

import { Ulid } from './primitives';

/** `POST /drm/widevine/:songId` — body/response are raw license bytes, not JSON. */
export const DrmParams = z.object({ songId: Ulid });
export type DrmParams = z.infer<typeof DrmParams>;

export const WIDEVINE_KEY_SYSTEM = 'com.widevine.alpha';
/** `KEYFORMAT` uuid the package verifier looks for in `#EXT-X-KEY` (docs/03 §2). */
export const WIDEVINE_KEYFORMAT_UUID = 'edef8ba9-79d6-4ace-a3c8-27dcd51d21ed';
export const LICENSE_CONTENT_TYPE = 'application/octet-stream';

/** Builds the license URL the API puts in `PlayResponse.drm` (docs/07 §4). */
export function widevineLicensePath(songId: string): string {
  return `/drm/widevine/${songId}`;
}

/** `GET /keys/:songId` — AES-128 fallback: 16 raw key bytes. */
export const KeysParams = z.object({ songId: Ulid });
export type KeysParams = z.infer<typeof KeysParams>;
export const AES_KEY_LENGTH = 16;

/** What the player needs to configure DRM (docs/04 §4 `IPlayerAdapter.load`). */
export interface DrmConfig {
  widevineLicenseUrl: string;
  /** `Authorization: Bearer <idToken>` is added by the adapter's request filter. */
  headers: Record<string, string>;
}
